import React from 'react';
import BaseButtonText from '../../sisu/button/BaseButtonText.sisu';

const NeoButtonText = (props) => {
  return (<>
    <BaseButtonText custom='p-button-link' {...props}/>
  </>);
};

export default NeoButtonText;